module.exports = __webpack_public_path__ + "img/avatar.6f6bbb16.png";